import 'css-chunksrc/client/scenes/wbs/task/allocationsList/details/allocation/allocatedHours/styles.scss';export default {
  "allocatedHours": "_allocatedHours_4tk2l_1",
  "edition": "_edition_4tk2l_7",
  "input": "_input_4tk2l_11",
  "text": "_text_4tk2l_31"
};